import { mapMutations, mapState } from "vuex";
import moment from "moment";

import SquareMeterItem from "../SquareMeterItem.vue";
import SimpleItem from "../SimpleItem.vue";
import ServiceItem from "../ServiceItem.vue";
import ModalCreateCustomer from "../../../components/Modals/ModalCreateCustomer.vue";
import ModalCreateEmployees from "../../../components/Modals/ModalCreateEmployees.vue";
import ModalProductionOrder from "../ModalProductionOrder.vue"

import InputSelect from "../../../components/UI/CustomInputs/InputSelect.vue";
import Input from "../../../components/UI/CustomInputs/Input.vue";
import InputMoney from "../../../components/UI/CustomInputs/InputMoney.vue";
import InputQuant from "../../../components/UI/CustomInputs/InputQuant.vue";
import InputPercentage from "../../../components/UI/CustomInputs/InputPercentage.vue";
import InputInfinit from "../../../components/UI/CustomInputs/InputInfinit.vue";
import Tabs from "../../../components/UI/Tabs/Tab.vue"

import ServiceCustomer from "../../../services/serviceCustomer";
import ServiceProducts from "../../../services/serviceProducts";
import ServiceEmployees from "../../../services/serviceEmployees"
import ServiceProductionOrder from "../../../services/serviceProductionOrder";

import { ValidadeProductionOrder } from "../../../validators/productionOrder";

import { maskPercentage, maskCurrency, mascaraMoeda } from "../../../utils/maskMoney";
import { ProductionOrderSituationTypes } from "../../../utils/enums/ProductionOrderSituationTypes";
import { productionOrderSituations } from "../../../common";

export const mixinProductionOrder = {
  components: {
    InputSelect,
    Input,
    InputMoney,
    InputQuant,
    InputPercentage,
    InputInfinit,
    SquareMeterItem,
    SimpleItem,
    ServiceItem,
    ModalCreateCustomer,
    ModalCreateEmployees,
    ModalProductionOrder,
    Tabs,
  },
  data() {
    return {
      productionOrder: {
        id: "",
        idCliente: "",
        idFuncionario: "",
        situacao: ProductionOrderSituationTypes.pendente,
        codReferencia: "",
        dataInicio: moment().format("YYYY-MM-DD"),
        dataFim: null,
        dataEntrega: null,
        frete: 0,
        outrosValores: 0,
        observacoes: "",
        numero: ""
      },
      totalOfItens: 0,
      numberProductionOrder: "",
      allSituations: productionOrderSituations,
      maskPercentage: maskPercentage,
      createdNewCustomer: false,
      tabs: [
        { name: "simpleItem", text: "Produtos" },
        { name: "squareMeterItem", text: "Produtos MT2" },
        { name: "serviceItem", text: "Serviços" },
      ],
      tabSelected: 0,
      actionToAlterTab: false,
      maskCurrency: maskCurrency,
      listEmployees: [],
      isInvalidInput: "",
      serviceItemTotals: {
        totalOfItens: 0,
        discountOfItens: 0
      },
      simpleItemTotals: {
        totalOfItens: 0,
        discountOfItens: 0
      },
      squareMeterItemTotals: {
        totalOfItens: 0,
        discountOfItens: 0
      },
      productionOrderForModal: {
        customerName: "",
        employeeName: "",
        items: {
          simpleItem: [],
          squareMeterItem: [],
          serviceItem: []
        },
      },
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_SEARCH_FROM_PRODUCTION_ORDER"]),
    async handleSaveOrUpdate() {
      this.productionOrder.id ? this.update() : this.save()
    },

    async save() {
      try {
        const isValid = ValidadeProductionOrder(this.productionOrder);
        if (isValid && Object.keys(isValid).length) {
          return this.$toast.open({
            message: isValid.message,
            type: "info",
          });
        }

        const result = await ServiceProductionOrder.save(this.productionOrder)

        this.productionOrder.id = result.id
        this.productionOrder.numero = result.number

        this.$toast.open({
          message:
            "Ordem de produção simples registrada!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao salvar",
          type: "info",
        });
      }
    },

    async update() {
      try {
        const isValid = ValidadeProductionOrder(this.productionOrder);
        if (isValid && Object.keys(isValid).length) {
          return this.$toast.open({
            message: isValid.message,
            type: "info",
          });
        }

        await ServiceProductionOrder.update(this.productionOrder)

        this.$toast.open({
          message:
            "Ordem de produção simples atualizada!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao atualizar",
          type: "info",
        });
      }
    },

    async listCustomerWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceCustomer.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os clientes",
          type: "info",
        });
      }
    },

    async listProductsWithPaginate(id, q, filterType, page) {
      try {
        return await ServiceProducts.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os produtos",
          type: "info",
        });
      }
    },

    async listEmployeesSelectBox() {
      try {
        const result = await ServiceEmployees.getEmployeesForSelectBox();
        this.listEmployees = result.data
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao listar os funcionários",
          type: "info",
        });
      }
    },

    handleDataToSendModalProductionOrder() {
      if (!this.productionOrder.id) return

      this.handleEmployeeFromModal()
      this.openModals("modalProductionOrder");
    },

    handleFreteMonetaryValue(event) {
      this.productionOrder.frete = mascaraMoeda(event.target.value);
    },

    handleOtherValuesMonetaryValue(event) {
      this.productionOrder.outrosValores = mascaraMoeda(event.target.value);
    },

    handleSaveByProductionOrderItems(value) {
      this.productionOrder.id = value.id
      this.productionOrder.numero = value.number
    },

    handleCalcTotalValues(total, type) {
      this[type].totalOfItens = total
    },

    handleCalcDiscountValues(discount, type) {
      this[type].discountOfItens = discount
    },

    handleCustomersFromModal(customer) {
      this.productionOrderForModal.customerName = customer?.nome
    },

    handleEmployeeFromModal() {
      this.productionOrderForModal.employeeName = this.listEmployees.find(emp => emp.id === this.productionOrder.idFuncionario)?.nomeFuncionario
    },

    handleCreatedNewCustomer() {
      this.createdNewCustomer = !this.createdNewCustomer;
    },

    clearInvalidInput() {
      this.isInvalidInput = "";
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },

    clear() {
      this.productionOrder = {
        id: "",
        idCliente: "",
        idFuncionario: "",
        situacao: ProductionOrderSituationTypes.pendente,
        codReferencia: "",
        dataInicio: moment().format("YYYY-MM-DD"),
        dataFim: null,
        dataEntrega: null,
        frete: 0,
        outrosValores: 0,
        observacoes: "",
        numero: ""
      }

      this.$refs.codReferencia.valueInput = ""
      this.$refs.dataInicio.valueInput = ""
      this.$refs.dataFim.valueInput = ""
      this.$refs.dataEntrega.valueInput = ""
      this.$refs.funcionario.valueItems = ""
      this.$refs.situacao.valueItems = ProductionOrderSituationTypes.pendente
    },

    assingRefs() {
      this.$refs.codReferencia.valueInput = this.productionOrder.codReferencia
      this.$refs.dataInicio.valueInput = this.productionOrder.dataInicio
      this.$refs.dataFim.valueInput = this.productionOrder.dataFim
      this.$refs.dataEntrega.valueInput = this.productionOrder.dataEntrega
      this.$refs.funcionario.valueItems = this.productionOrder.idFuncionario
      this.$refs.situacao.valueItems = this.productionOrder.situacao
    },
  },
  computed: {
    ...mapState({
      dataConfig: (state) => state.dataConfig,
      dataSearchFromProductionOrder: (state) => state.dataSearchFromProductionOrder,
    }),
    decimalPlaces() {
      if (Object.keys(this.dataConfig).length) {
        return Number(this.dataConfig?.venda_mtq?.casas_decimais)
      }

      return 2;
    },
    handleTotalProductionOrder() {
      const total = this.simpleItemTotals.totalOfItens +
        this.squareMeterItemTotals.totalOfItens +
        this.serviceItemTotals.totalOfItens +
        this.productionOrder.frete +
        this.productionOrder.outrosValores

      return (total - this.handleDiscountProductionOrder) || 0
    },
    handleDiscountProductionOrder() {
      const discount = this.simpleItemTotals.discountOfItens + this.squareMeterItemTotals.discountOfItens + this.serviceItemTotals.discountOfItens
      return discount || 0
    },
    objectTotal() {
      const totalItems = this.simpleItemTotals.totalOfItens +
        this.squareMeterItemTotals.totalOfItens +
        this.serviceItemTotals.totalOfItens

      return {
        totalItems: totalItems,
        frete: this.productionOrder.frete,
        otherValues: this.productionOrder.outrosValores,
        totalDiscount: this.handleDiscountProductionOrder,
        total: this.handleTotalProductionOrder,
      };
    },
  },
  watch: {
  },
  mounted() {
    this.listEmployeesSelectBox()

    if (
      this.dataSearchFromProductionOrder &&
      Object.keys(this.dataSearchFromProductionOrder).length
    ) {
      Object.assign(this.productionOrder, this.dataSearchFromProductionOrder);
      this.assingRefs()
    }
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_PRODUCTION_ORDER({});
  },
}
